export const handleCopyButtons = () => {
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".copy-code-btn");
    if (!btn) return;

    const code = btn.dataset.code;
    if (!code) return;

    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(code)
        .then(() => {
          btn.textContent = wp.i18n.__('Copied !', 'smartwood');
          btn.classList.add("copied");

          setTimeout(() => {
            btn.textContent = wp.i18n.__('Copy the code', 'smartwood');
            btn.classList.remove("copied");
          }, 3000);
        })
        .catch((err) => console.error("Copy error :", err));
    } else {
      console.warn("Clipboard API not supported");
    }
  });
};

export const initBannerCodeCopy = () => {
  document.addEventListener("click", (e) => {
    const banner = e.target.closest(".banner-copy-code");
    if (!banner) return;

    const code = banner.dataset.code;
    if (!code) return;

    e.preventDefault();

    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(code)
        .then(() => {
          /* translators: %s = code */
          showToast(wp.i18n.sprintf(wp.i18n.__('The code "%s" has been copied', 'smartwood'), code));
        })
        .catch((err) => {
          console.error("Copy error :", err);
        });
    } else {
      console.warn("The Clipboard API is not supported");
    }
  });
};

export const showToast = (message) => {
  const toast = document.createElement("div");
  toast.className = "custom-notify";
  toast.textContent = message;

  document.body.appendChild(toast);

  setTimeout(() => {
    toast.classList.add("visible");
  }, 10);

  setTimeout(() => {
    toast.classList.remove("visible");
    setTimeout(() => toast.remove(), 300);
  }, 3000);
};
